module.exports = __webpack_public_path__ + "img/personel-detail-6.png";